import { useState, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';

export default function InAppBrowserGuard() {
    const [isInAppBrowser, setIsInAppBrowser] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isInstagram = (ua.indexOf('Instagram') > -1);
        const isFacebook = (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
        const isMessenger = (ua.indexOf('FB_IAB') > -1) || (ua.indexOf('Messenger') > -1);
        const isLine = (ua.indexOf('Line') > -1);
        const isLinkedIn = (ua.indexOf('LinkedIn') > -1);

        if (isInstagram || isFacebook || isMessenger || isLine || isLinkedIn) {
            setIsInAppBrowser(true);
        }
    }, []);

    if (!isInAppBrowser) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95 p-6 text-center text-white backdrop-blur-xl animate-fade-in">
            <div className="max-w-md w-full bg-neutral-900/80 backdrop-blur-2xl rounded-[2rem] border border-white/10 shadow-2xl p-8 relative overflow-hidden">
                {/* Decorative Background */}
                <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-br from-purple-500/20 to-pink-500/20 blur-2xl pointer-events-none"></div>

                <div className="relative z-10 flex flex-col items-center">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center mb-6 border border-white/10 animate-pulse-slow">
                        <ExternalLink size={36} className="text-purple-300" />
                    </div>

                    <h2 className="text-3xl font-black text-white mb-3 tracking-tight">Ope! Let's scooch ya over.</h2>

                    <p className="text-neutral-400 mb-8 leading-relaxed">
                        Looks like you're stuck in an in-app browser. We don't play nice with those (they block some of the fun stuff).
                    </p>

                    <div className="w-full bg-white/5 border border-white/10 rounded-2xl p-6 relative">
                        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-purple-600 rounded-full text-[10px] font-bold uppercase tracking-widest shadow-lg">
                            Quick Fix
                        </div>
                        <p className="text-sm font-medium text-neutral-300 mb-2">
                            Tap the <span className="inline-block bg-white/10 px-1.5 rounded mx-0.5">•••</span> or <span className="inline-block bg-white/10 px-1.5 rounded mx-0.5">Share</span> button and select:
                        </p>
                        <div className="font-bold text-white text-lg bg-black/30 py-3 rounded-xl border border-white/5">
                            "Open in Browser"
                        </div>
                    </div>

                    <div className="mt-8 text-xs text-neutral-600 font-medium">
                        (Preferably Chrome or Safari)
                    </div>
                </div>
            </div>
        </div>
    );
}
